import React, { useEffect } from 'react'
import axios from 'axios'

import { HiLogout } from 'react-icons/hi'
import { useStateValue } from '../Utils/StateProvider';
import { useCookies } from 'react-cookie';

const sessionDuration = 1000 * 60 * 15

const LogoutButton = () => {
    const [cookies, removeCookie] = useCookies(['bearerToken', 'uid', 'alive']);
    const [{ url }, payload] = useStateValue()

    const logout = async () => {
        try {
            await axios.patch(`${url}/api/u/auth`, {}, {
                headers: {
                    Authorization: `Bearer ${cookies.bearerToken}`
                }
            })
            removeCookie('bearerToken')
            removeCookie('uid')
            removeCookie('alive')
            localStorage.removeItem('customer')
            payload({
                type: 'TOGGLE_HEADER',
                state: true
            })
            
        }catch (err) {
            console.error(err.response.data.message)
        }
    }

    const checkForInactivity = () => {
        const expTime = localStorage.getItem('expTime')
        const now = new Date().getTime()

        if ((expTime - now)/(sessionDuration/100) <= 20) payload({
            type: 'SET_NOTIFY',
            data: {
                text: `Are you still with us? Your account will be logged out in ${Math.floor((expTime - now) / 1000)} second(s) if no activity is recorded. This is to provide more security to your personal data and assets.`,
                status: 'warn'
            }
        })
        if (expTime < now) {payload({
            type: 'CLEAR_NOTIFY'
        })
            logout()
        }
    }

    const updateExpTime = () => {
        let expTime = new Date().getTime() + sessionDuration
        localStorage.setItem('expTime', expTime)
    }

    useEffect(() => {
        updateExpTime()

        window.addEventListener('click', updateExpTime)
        window.addEventListener('keypress', updateExpTime)
        window.addEventListener('scroll', updateExpTime)
        window.addEventListener('mousemove', updateExpTime)

        const interval = setInterval(() => {
            checkForInactivity()
        }, 1000)

        return () => {
            // ['click', 'keypress', 'scroll', 'mousemove'].forEach(event => window.removeEventListener(event, updateExpTime))
            window.removeEventListener('click', updateExpTime)
            window.removeEventListener('keypress', updateExpTime)
            window.removeEventListener('scroll', updateExpTime)
            window.removeEventListener('mousemove', updateExpTime)
            clearInterval(interval)
        }
    }, [])

    return (
        cookies.bearerToken && ![undefined, 'undefined', null, 'null'].includes(cookies.bearerToken) && (
            <button onClick={logout}>
                Logout
                <HiLogout />
            </button>
        )
    )
}

export default LogoutButton
